import "./namespace.js";
import.meta.glob("./viewer/templates/**/*.{js,hbs,jst.ejs}", { eager: true });
import "../../../shared/components/modal.js";

window.Sparkle ??= {};
window.Sparkle.PatientJourneyManager ??= {};
window.Sparkle.PatientJourneyManager.PatientDocuments ??= {};

Sparkle.PatientJourneyManager.PatientDocuments.Viewer = class Viewer {
  constructor(patientDocument) {
    this.render = this.render.bind(this);
    this.print = this.print.bind(this);
    this.patientDocument = patientDocument;
    this.modal = new Modal({ destroyOnHide: true, class: "default-modal patient-document-viewer" });
    this.el = this.modal.container;

    // BEHAVIOUR

    jQuery(this.el).on("click", '[data-patient-document-viewer-behaviour="print"]', this.print);
    jQuery(this.el).on("keyup", '[data-patient-document-viewer-behaviour="print"]', (event) => {
      if (event.which === 13) {
        return this.print();
      }
    });
  }

  // RENDERING

  render() {
    this.modal.setHeader(this.patientDocument.name);
    this.modal.setBody(this.renderTemplate("modal_body", { patientDocument: this.patientDocument }));
    this.modal.show();
    return this.el.find(".preview-toolbar").focus(); // Accessibility
  }

  renderTemplate(template, context) {
    return JST[`admin/patient_journey_manager/patient_documents/viewer/templates/${template}`](context);
  }

  // HELPER METHODS

  print() {
    const iframe = jQuery("<iframe>", { width: 0, height: 0, frameborder: 0, src: this.patientDocument.url }).appendTo(
      this.el,
    );
    return iframe.prop("contentWindow").print();
  }
};
